import React, { useState } from "react";
import "./Tyre.css";
import Breadcrumb from "../../../../components/Breadcrum";
import { Modal, Button } from "react-bootstrap";

const PcrTyres = () => {
  const tyreData = [
    {
      id: 1,
      name: "DH01",
      outerImg: "/assets/img/pcr/outer-images/DH01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH01.jpg",
    },
    {
      id: 2,
      name: "DH02",
      outerImg: "/assets/img/pcr/outer-images/DH02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH02.jpg",
    },
    {
      id: 3,
      name: "DH05",
      outerImg: "/assets/img/pcr/outer-images/DH05.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH05.jpg",
    },
    {
      id: 4,
      name: "DL01",
      outerImg: "/assets/img/pcr/outer-images/DL01.jpg", 
      innerImg: "/assets/img/pcr/inner-images/DL01.jpg",
    },
    {
      id: 5,
      name: "DS01",
      outerImg: "/assets/img/pcr/outer-images/DS01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS01.jpg",
    },
    {
      id: 6,
      name: "DS02",
      outerImg: "/assets/img/pcr/outer-images/DS02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS02.jpg",
    },
    {
      id: 7,
      name: "DS315",
      outerImg: "/assets/img/pcr/outer-images/DS315.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS315.jpg",
    },
    {
      id: 8,
      name: "DS703",
      outerImg: "/assets/img/pcr/outer-images/DS703.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS703.jpg",
    },
    {
      id: 9,
      name: "DS706",
      outerImg: "/assets/img/pcr/outer-images/DS706.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS706.jpg",
    },
    {
      id: 10,
      name: "DS766",
      outerImg: "/assets/img/pcr/outer-images/DS766.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS766.jpg",
    },
    {
      id: 11,
      name: "DS805",
      outerImg: "/assets/img/pcr/outer-images/DS805.jpg",
      innerImg: "/assets/img/pcr/inner-images/DS805.jpg",
    },
    {
      id: 12,
      name: "DSS02",
      outerImg: "/assets/img/pcr/outer-images/DSS02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DSS02.jpg",
    },
    {
      id: 13,
      name: "DU01",
      outerImg: "/assets/img/pcr/outer-images/DU01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DU01.jpg",
    },
    {
      id: 14,
      name: "DW01",
      outerImg: "/assets/img/pcr/outer-images/DW01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DW01.jpg",
    },
    {
      id: 15,
      name: "T01",
      outerImg: "/assets/img/pcr/outer-images/T01.jpg",
      innerImg: "/assets/img/pcr/inner-images/T01.jpg",
    },
    {
      id: 16,
      name: "W01",
      outerImg: "/assets/img/pcr/outer-images/W01.jpg",
      innerImg: "/assets/img/pcr/inner-images/W01.jpg",
    },
    {
      id: 17,
      name: "APEX RACING",
      outerImg: "/assets/img/pcr/outer-images/APEX RACING.jpg",
      innerImg: "/assets/img/pcr/inner-images/APEX RACING.jpg",
    },
    {
      id: 18,
      name: "DH03",
      outerImg: "/assets/img/pcr/outer-images/DH03.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH03.jpg",
    },
    {
      id: 19,
      name: "DH08",
      outerImg: "/assets/img/pcr/outer-images/DH08.jpg",
      innerImg: "/assets/img/pcr/inner-images/DH08.jpg",
    },
    {
      id: 20,
      name: "DLA01",
      outerImg: "/assets/img/pcr/outer-images/DLA01.jpg",
      innerImg: "/assets/img/pcr/inner-images/DLA01.jpg",
    },
    {
      id: 21,
      name: "DLA02",
      outerImg: "/assets/img/pcr/outer-images/DLA02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DLA02.jpg",
    },
    {
      id: 22,
      name: "DSU02",
      outerImg: "/assets/img/pcr/outer-images/DSU02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DSU02.jpg",
    },
    {
      id: 23,
      name: "DW02",
      outerImg: "/assets/img/pcr/outer-images/DW02.jpg",
      innerImg: "/assets/img/pcr/inner-images/DW02.jpg",
    },
    {
      id: 24,
      name: "DW06",
      outerImg: "/assets/img/pcr/outer-images/DW06.jpg",
      innerImg: "/assets/img/pcr/inner-images/DW06.jpg",
    },

    // 🆕 Newly added images below
    {
      id: 25,
      name: "DW08",
      outerImg: "/assets/img/pcr/outer-images/DW08.jpg",
      innerImg: "/assets/img/pcr/inner-images/DW08.jpg",
    },
    {
      id: 26,
      name: "HH307",
      outerImg: "/assets/img/pcr/outer-images/HH307.jpg",
      innerImg: "/assets/img/pcr/inner-images/HH307.jpg",
    },
    {
      id: 27,
      name: "HM003",
      outerImg: "/assets/img/pcr/outer-images/HM003.jpg",
      innerImg: "/assets/img/pcr/inner-images/HM003.jpg",
    },
    {
      id: 28,
      name: "HR602",
      outerImg: "/assets/img/pcr/outer-images/HR602.jpg",
      innerImg: "/assets/img/pcr/inner-images/HR602.jpg",
    },
    {
      id: 29,
      name: "HR607",
      outerImg: "/assets/img/pcr/outer-images/HR607.jpg",
      innerImg: "/assets/img/pcr/inner-images/HR607.jpg",
    },
    {
      id: 30,
      name: "HR701",
      outerImg: "/assets/img/pcr/outer-images/HR701.jpg",
      innerImg: "/assets/img/pcr/inner-images/HR701.jpg",
    },
    {
      id: 31,
      name: "HR801",
      outerImg: "/assets/img/pcr/outer-images/HR801.jpg",
      innerImg: "/assets/img/pcr/inner-images/HR801.jpg",
    },
    {
      id: 32,
      name: "HR802",
      outerImg: "/assets/img/pcr/outer-images/HR802.jpg",
      innerImg: "/assets/img/pcr/inner-images/HR802.jpg",
    },
    {
      id: 33,
      name: "HR807",
      outerImg: "/assets/img/pcr/outer-images/HR807.jpg",
      innerImg: "/assets/img/pcr/inner-images/HR807.jpg",
    },
    {
      id: 34,
      name: "HU901",
      outerImg: "/assets/img/pcr/outer-images/HU901.jpg",
      innerImg: "/assets/img/pcr/inner-images/HU901.jpg",
    },
    {
      id: 35,
      name: "HU907",
      outerImg: "/assets/img/pcr/outer-images/HU907.jpg",
      innerImg: "/assets/img/pcr/inner-images/HU907.jpg",
    },
    {
      id: 36,
      name: "HW501",
      outerImg: "/assets/img/pcr/outer-images/HW501.jpg",
      innerImg: "/assets/img/pcr/inner-images/HW501.jpg",
    },
    {
      id: 37,
      name: "HW505",
      outerImg: "/assets/img/pcr/outer-images/HW505.jpg",
      innerImg: "/assets/img/pcr/inner-images/HW505.jpg",
    },
    {
      id: 38,
      name: "HW507",
      outerImg: "/assets/img/pcr/outer-images/HW507.jpg",
      innerImg: "/assets/img/pcr/inner-images/HW507.jpg",
    },
    {
      id: 39,
      name: "HW508",
      outerImg: "/assets/img/pcr/outer-images/HW508.jpg",
      innerImg: "/assets/img/pcr/inner-images/HW508.jpg",
    },
    {
      id: 40,
      name: "NEW ENERGY TIRE EV95",
      outerImg: "/assets/img/pcr/outer-images/NEW ENERGY TIRE EV95.jpg",
      innerImg: "/assets/img/pcr/inner-images/NEW ENERGY TIRE EV95.jpg",
    },
    {
      id: 41,
      name: "PMS01",
      outerImg: "/assets/img/pcr/outer-images/PMS01.jpg",
      innerImg: "/assets/img/pcr/inner-images/PMS01.jpg",
    },
    {
      id: 42,
      name: "PMS02",
      outerImg: "/assets/img/pcr/outer-images/PMS02.jpg",
      innerImg: "/assets/img/pcr/inner-images/PMS02.jpg",
    },
  ];

  const [selectedTyre, setSelectedTyre] = useState(null);

  const openModal = (tyre) => setSelectedTyre(tyre);
  const closeModal = () => setSelectedTyre(null);

  return (
    <>
      <Breadcrumb
        title="PCR CATALOGUE"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      />

      <section className="lyt-section tyers-section PCR-CATALOGUE">
        <div className="container">
          <h2 className="heading01 text-center">
            <span>PCR</span> CATALOGUE
          </h2>

          {/* ✅ Tyre Grid */}
          <div className="tyre-grid">
            {tyreData.map((tyre) => (
              <div
                className="tyre-box"
                key={tyre.id}
                onClick={() => openModal(tyre)}
              >
                <div className="imageWrapper">
                  {/* ✅ OUTER image */}
                  <img src={tyre.outerImg} alt={tyre.name} className="image" />
                </div>

                <h4 className="text-center">{tyre.name}</h4>
              </div>
            ))}
          </div>

          {/* ✅ MODAL */}
          <Modal show={!!selectedTyre} onHide={closeModal} centered className="custom">
            <Modal.Header closeButton>
              <Modal.Title>{selectedTyre?.name}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              {/* ✅ INNER popup image */}
              <img
                src={selectedTyre?.innerImg}
                alt={selectedTyre?.name}
                style={{ width: "100%", height: "auto" }}
              />
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={closeModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </section>
    </>
  );
};

export default PcrTyres;
